import React from 'react';
import PropTypes from 'prop-types';

import { Row, Column } from 'mage-components';
import { SpacerVertical } from '@klarna/bubble-ui';

import { DocumentUpload } from '@/components';

export const DocumentsBlock = ({
  stakeholderId,
  stakeholderRoles = [],
  documentRequirements = [],
  uploadedDocuments = [],
}) => {
  return (
    <Row spacing={{ mobile: 0, tablet: 0, desktop: 2 }}>
      {documentRequirements.map(({ attachmentType, required }, index) => (
        <Column
          key={index}
          columns={{
            mobile: 12,
            tablet: 12,
            desktop: 12,
          }}
        >
          {index > 0 && <SpacerVertical medium />}

          <DocumentUpload
            type={attachmentType}
            metadata={{ stakeholderId, stakeholderRoles }}
            required={required}
            documents={uploadedDocuments.filter(
              doc =>
                (!stakeholderId || doc.stakeholderId === stakeholderId) &&
                doc.type === attachmentType,
            )}
          />
        </Column>
      ))}
    </Row>
  );
};

DocumentsBlock.propTypes = {
  documentRequirements: PropTypes.array,
  stakeholderId: PropTypes.string,
  stakeholderRoles: PropTypes.array,
  uploadedDocuments: PropTypes.array,
};
